
import { ConfiguracionesService } from '../../../../../shared/configuraciones.service';
import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatDialogRef,MAT_DIALOG_DATA} from '@angular/material/dialog'
import { formatDate } from '@angular/common';

export interface DialogData {
  id: string;
  departamento: string;
}

@Component({
  selector: 'app-DialogAgregarDepartamentos',
  templateUrl: './DialogAgregarDepartamentos.component.html',
  styleUrls: ['./DialogAgregarDepartamentos.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class DialogAgregarDepartamentos implements OnInit {
  id: string;
  departamento: string;
  constructor(public dialogRef: MatDialogRef<DialogAgregarDepartamentos>, 
     @Inject(MAT_DIALOG_DATA) public data: DialogData,private configuracionesService: ConfiguracionesService, public toastr: ToastrManager) {}


  ngOnInit(): void {

 
  
  }

  onNoClick(): void {
    console.log('cerrado');
    this.dialogRef.close();
  
  }
 
  crearTipoDocumento(data: any) {
   

    console.log('tipodocumento',data);
    if(data.departamento) {

      if(data.departamento) {

          
    var conop = {
      con: data.id+1

    }

    this.configuracionesService.incrementarDepartamento(conop)

    var des = data.departamento;
    var may = des.substring(0, 1).toUpperCase();
    var res = des.substring(1, des.length).toLowerCase();

    var departamento = may.concat(res.toString())
        
  
     
        var tipoDoc = {
          id: data.id,
          departamento: departamento,
      
        }
  
        var hoy = new Date();
        var minuto=  hoy.getMinutes() 
        var segundos=hoy.getSeconds()
    
        var minutefinal="00"
        var segundofinal="00"
        if(minuto<10){
    
          minutefinal="0"+minuto
        }else{
          minutefinal=String(minuto)
        }
        if(segundos<10){
    
          segundofinal="0"+segundos
        }else{
          segundofinal=String(segundos)
        }
        var hora = hoy.getHours() + ':' + minutefinal + ':' + segundofinal;
        var auditria = {
          id:data.id,
          usuario:  localStorage.getItem("responsable"),
          hora:  hora,
          fechahora: formatDate(hoy, 'yyyy-MM-dd HH:mm:ss', 'en-US'),
          fecha: formatDate(hoy, 'yyyy-MM-dd', 'en-US'),
          movimiento:  'Agregar',
          departamento:data.departamento
    
        }
    
        this.configuracionesService.crearAuditriaDepartamento(auditria)
        this.configuracionesService.crearDepartamento(tipoDoc)
        this.toastr.successToastr("Departamento: "+departamento+ " creado con éxito", 'Notificación');
        this.dialogRef.close();

      }else{
        this.toastr.errorToastr("Departamento", 'Notificación');
  
      } 

    }else{
      this.toastr.errorToastr("Departamento", 'Notificación');

    } 



  }
  
}
